export default __webpack_public_path__ + "static/media/bg_6.20dc63fa.jpg";